import {
  FETCH_RVU_REPORT,
  FETCH_RVU_REPORT_SUCCESS,
  FETCH_RVU_REPORT_ERROR,
} from './rvuReport.types'

export const fetchRvuReport = (params) => ({
  type: FETCH_RVU_REPORT,
  payload: params,
})

export const fetchRvuReportSuccess = (data) => ({
  type: FETCH_RVU_REPORT_SUCCESS,
  payload: data,
})

export const fetchRvuReportError = (error) => ({
  type: FETCH_RVU_REPORT_ERROR,
  payload: error,
})
